class ThemeToggleButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.toggle());
    this.syncAria();
  }

  toggle() {
    const root = document.documentElement;
    const current = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    const next = current === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try {
      localStorage.setItem('theme-color-scheme', next);
    } catch (error) {
      // Ignore storage errors (private browsing, disabled storage, etc.)
    }
    this.syncAria();
  }

  syncAria() {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    this.button.setAttribute('aria-pressed', String(isDark));
  }
}

if (!customElements.get('theme-toggle-button')) {
  customElements.define('theme-toggle-button', ThemeToggleButton);
}
